import { configRequest } from 'config-request';
import { defineStore } from 'pinia';
import { useGlobalStore } from './global';
import { useFeatureListStore } from './feature-list';
import { useShowAllListStore } from './show-all-list';
import { getRequestIns } from '../requestIns';
export const useSaveConfigStore = defineStore('save-config', {
    actions: {
        /**
         * 保存心愿单
         */
        async saveConfig(token, conf_no = '', optionsList = [], quotation_no = '') {
            const globalStore = useGlobalStore();
            const featureListStore = useFeatureListStore();
            const showAllListStore = useShowAllListStore();
            const generationCode = globalStore.currentOptions.generation_code ||
                showAllListStore.data?.generation_code ||
                '';
            const optionMap = featureListStore.data?.option_map;
            const option_list = optionsList.length
                ? optionsList.map((item) => ({
                    feature_code: item.feature_code,
                    code: item.code,
                    name: item.name,
                }))
                : globalStore.currentOptionList.map((item) => ({
                    ...item,
                    name: optionMap?.[item.code]?.name ?? '',
                }));
            const params = {};
            if (quotation_no) {
                params.quotation_no = quotation_no;
            }
            const result = await configRequest(getRequestIns()).save(conf_no
                ? {
                    generation_code: generationCode,
                    option_list: option_list,
                    conf_no,
                    ...params,
                }
                : {
                    generation_code: generationCode,
                    option_list: option_list,
                    ...params,
                }, {
                // header: {
                //   token,
                //   Authorization: `Bearer ${token}`,
                // },
                showToast: true,
                throwError: true,
            });
            return result?.data ?? null;
        },
    },
});
